"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function baseProps(props) {
  var tabIndex = props.tabIndex,
      testId = props.testId,
      title = props.title,
      onClick = props.onClick,
      onContextMenu = props.onContextMenu,
      onMouseDown = props.onMouseDown,
      id = props.id;
  return {
    'data-test-id': testId,
    tabIndex: tabIndex,
    title: title,
    onContextMenu: onContextMenu,
    onClick: onClick,
    onMouseDown: onMouseDown,
    id: id
  };
}

function noop() {// Нужна чтобы не забивать память кучей пустых функций
}

exports.noop = noop;

function isFunctionalProp(prop) {
  return typeof prop === 'function';
}

function functionalProp(prop, options) {
  return isFunctionalProp(prop) ? prop(options) : prop;
}

exports.functionalProp = functionalProp;
exports.default = baseProps;